import React, { useState } from "react";
import EventList from "./EventList";
import EventForm from "./EventForm";

import "./Events.scss";
import PreviousEventsPopup from "./PreviousEventsPopup";

function Events() {

    const [openViewPreviousTopics, setOpenViewPreviousTopics] = useState(false);

    const handleOpenPreviousTopicsPopup = () => {
        setOpenViewPreviousTopics(prev => !prev);
    }

  return (
    <>
      <div className="row mb-5 mt-0 mx-2">
        <div className="col-12 col-md-8">
          <EventList />
        </div>
        <div className="col-12 col-md-4 mt-4 mt-md-0">
          <EventForm />
          <div
            className="btn events-border p-2 rounded mt-3 w-100 previous-event-btn"
            onClick={handleOpenPreviousTopicsPopup}
            data-toggle="modal"
            data-target="#previousEvents"
          >
            View Previous Events & Topics
          </div>
        </div>
      </div>
      <PreviousEventsPopup open={openViewPreviousTopics} />
    </>
  );
}

export default Events;
